import Burger from "../../../components/Burger";
import React from "react";

const HomeBurger = () => {
    return <Burger/>
}

HomeBurger.propTypes = {

}

export default HomeBurger;